import { Text, Tooltip } from "@mantine/core";
import { IconMicrophone, IconSparkles } from "@tabler/icons-react";
import { useSnapshot } from "valtio";
import { i18nStore } from "@/store/i18n";
import { VOICE_START_CLASS, voiceStartCss } from "./voice-start.styles";

/** Tombol kapsul gradasi "Mulai bicara dengan {name}"; redup tanpa glow saat nonaktif. */
export function VoiceStartButton({
	label,
	hint,
	reason,
	onClick,
}: {
	label: string;
	hint: string;
	/** Alasan tombol nonaktif (browser/izin); null = aktif. */
	reason: string | null;
	onClick(): void;
}) {
	const { animasiTransisi } = useSnapshot(i18nStore);
	return (
		<>
			<style>{voiceStartCss(animasiTransisi)}</style>
			<Tooltip label={reason} disabled={!reason} withArrow multiline w={240}>
				<span style={{ display: "block" }}>
					<button
						type="button"
						className={VOICE_START_CLASS}
						disabled={!!reason}
						onClick={onClick}
						aria-label={label}
						data-voice-start
					>
						<span data-vs-badge aria-hidden="true">
							<IconMicrophone size={16} />
						</span>
						<span style={{ flex: 1, minWidth: 0 }}>
							<Text size="sm" fw={600} lh={1.25} c="inherit" truncate>
								{label}
							</Text>
							<Text size="xs" lh={1.25} data-vs-sub truncate>
								{hint}
							</Text>
						</span>
						<IconSparkles
							size={16}
							aria-hidden="true"
							style={{ flex: "none" }}
						/>
					</button>
				</span>
			</Tooltip>
		</>
	);
}
